/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ChatModelRef } from './chat-model-ref';


export interface SetChatAgentRequest { 
    /**
     * The model the chat runs on from its next request; must be one GET /models allows the program.
     */
    model?: ChatModelRef;
    /**
     * How much the model thinks before answering (\"low\" fastest, \"high\" most thorough).
     */
    reasoning?: SetChatAgentRequest.ReasoningEnum;
}
export namespace SetChatAgentRequest {
    export type ReasoningEnum = 'low' | 'medium' | 'high';
    export const ReasoningEnum = {
        Low: 'low' as ReasoningEnum,
        Medium: 'medium' as ReasoningEnum,
        High: 'high' as ReasoningEnum
    };
}


